import React, { useState } from 'react'
import { Avatar, Button, Card, Divider, Popconfirm, Table } from 'antd'
import moment from 'moment'
import { compose, graphql, withApollo } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import HeroPromoteView from './HeroPromoteView'
import _ from 'lodash'
import {
  fetchHeroPromoteList,
  deleteHeroPromote
} from '../../modules/heroPromote'
import { ANNOUNCEMENT_STATUS } from '../../utils/constants'

const HeroPromote = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})

  const { heroPromoteList, isLoading } = useSelector(
    (state) => ({
      heroPromoteList: state.heroPromote.heroPromoteList,
      isLoading: state.heroPromote.isLoading
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchHeroPromoteList())
    }
    fetch()
  }, [])

  const columns = [
    {
      title: 'วันที่ประกาศ',
      dataIndex: 'createdDate',
      key: 'createdDate',
      render: (date) => <span>{moment(date).format('DD/MM/YYYY')}</span>
    },
    {
      title: 'Material',
      dataIndex: 'material.productImage',
      key: 'matImg',
      render: (matImg) => (
        <div>
           <Avatar key={matImg} src={matImg} size={43} />
        </div>
      )
    },
    {
      title: 'Min Quantity',
      dataIndex: 'material',
      key: 'minQuantity',
      render: (row) => {
        switch (row.minQuantity) {
          case 'NO_LIMIT': {
            return 'ไม่จำกัด'
          }
          case 'UNIT_10': {
            return '> 10'
          }
          case 'UNIT_100': {
            return '> 100'
          }
          case 'UNIT_1000': {
            return '> 1000'
          }
          default: {
            return 'Not Specify'
          }
        }
      }
    },
    {
      title: 'รวม VAT',
      key: 'includeVat',
      dataIndex: 'material.calculateVat',
      render: (includeVat) => <span>{includeVat ? 'ใช่' : 'ไม่'}</span>
    },
    {
      title: 'สถานะประกาศ',
      key: 'status',
      dataIndex: 'status',
      render: (status) => <span>{ANNOUNCEMENT_STATUS[status]}</span>
    },
    {
      title: 'ผู้ประกาศ',
      key: 'heroName',
      dataIndex: 'name',
      render: (heroName) => <span>{heroName}</span>
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="eye"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }

  const onCloseModal = async () => {
    await dispatch(fetchHeroPromoteList())
    await setVisible(false)
  }

  const onDelete = async (id) => {
    await dispatch(deleteHeroPromote(id))
    await dispatch(fetchHeroPromoteList())
  }

  return (
    <Card title="Hero Promote">
      <br />
      <Table
        loading={isLoading}
        bordered
        dataSource={heroPromoteList}
        columns={columns}
        rowKey={(record) => {
          return record.id
        }}
      />
      <HeroPromoteView
        visible={visible}
        formData={formData}
        onCancel={onCloseModal}
      />
    </Card>
  )
}

export default compose(
  withApollo,
)(HeroPromote)
